module.exports = __webpack_public_path__ + "img/variant-test.75189d93.jpg";